import classNames from 'classnames';
import React from 'react';

function PointLeft({ color = 'text-shuttle-grey', size = 'w-4 h-4' }) {
	return (
		<svg
			viewBox="0 0 16 16"
			className={classNames(color, size)}
			fillRule="evenodd"
			fill="none"
			transform="translate(1 1)"
			strokeWidth="2"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Icons---monochrome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" className="fill-current">
				<g id="export">
					<rect id="box" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16" />
					<path
						d="M0.444444444,8 C0.444444444,7.62344698 0.571053484,7.31536277 0.824275362,7.07573813 L7.50724638,0.390243902 C7.76731209,0.13008 8.07870189,0 8.44142512,0 C8.79730452,0 9.10527245,0.13008 9.36533816,0.390243902 L10.1352657,1.16046213 C10.3953314,1.4069332 10.5253623,1.71501741 10.5253623,2.08472401 C10.5253623,2.4544306 10.3953314,2.76251481 10.1352657,3.00898588 L7.12741546,6.02824134 L14.3544686,6.02824134 C14.710348,6.02824134 14.9994957,6.15660976 15.2219203,6.41335045 C15.4443449,6.67009114 15.5555556,6.97988693 15.5555556,7.34274711 L15.5555556,8.65725289 C15.5555556,9.02011307 15.4443449,9.32990886 15.2219203,9.58664955 C14.9994957,9.84339024 14.710348,9.97175866 14.3544686,9.97175866 L7.12741546,9.97175866 L10.1352657,12.9807445 C10.3953314,13.2409084 10.5253623,13.5524158 10.5253623,13.915276 C10.5253623,14.2781362 10.3953314,14.5896435 10.1352657,14.8498074 L9.36533816,15.6200257 C9.09842862,15.8733432 8.79046068,16 8.44142512,16 C8.08554572,16 7.77415592,15.8733432 7.50724638,15.6200257 L0.824275362,8.93453145 C0.571053484,8.68121397 0.444444444,8.3697066 0.444444444,8 Z"
						id="arrow-previous"
						fill="#000000"
					/>
				</g>
			</g>
		</svg>
	);
}

export default PointLeft;
